const paramsIndex = {
    title: 0,
    description: 1,
    list: 2,
    limit: 3,
    defer: 'defer'
};

export default class TransferData {
    [x: string]: any;
    setArguments(args) {
        this.args = args;
    }

    getArguments(key) {
        return this.args[paramsIndex[key]];
    }

}